/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import {
  MonitoredByTypes,
  MonitoringBiddingTypes,
  MonitoringRequestTypes,
} from 'store/modules/monitoring_store/types';
import MonitoringPortals from 'services/monitoring_portals';
import { useSelector, useDispatch } from 'react-redux';
import iconIA from 'assets/images/ia/icon-visao.svg';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import TradingId from 'components/molecules/trading_id';
import {
  archive,
  destroyElectronicsTradings,
  getTradingMessages,
  markAsRead,
  toggleImportant,
} from 'store/modules/monitoring_store/actions';
import Clipboard from 'services/clipboard';
import MonitoringInfoBiddingModal from 'components/molecules/monitoring_info_bidding_modal';
import companyId from 'services/company_id';
import BiddingDate from 'components/atoms/bidding_date';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import ModalNotes from 'components/atoms/modal_notes';
import { getComments } from 'store/modules/bidding_store/actions';
import IconActionButton from 'components/atoms/icon_action_button';
import DropdownActionItem from 'components/atoms/dropdown_action_item';
import { createMonitoreBidding } from 'services/actions/monitore_actions';
import MonitoringCompanyActionModal from 'components/molecules/monitoring_company_action_modal';
import { asksCompany, CompanyAction, ownCompanies } from 'services/monitoring_companies';

interface TradingContentItemProps {
  trading: MonitoringBiddingTypes | undefined;
  selectedTradingId: number;
  setShowSearchMessage: React.Dispatch<React.SetStateAction<boolean>>;
  setOverviewOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onCompaniesChanged: () => void;
}

const TradingContentItem = (props: TradingContentItemProps) => {
  const { trading, selectedTradingId, setShowSearchMessage, setOverviewOpen, onCompaniesChanged } =
    props;
  const [balloonText, setBalloonText] = useState<string>('Clique para copiar o número.');
  const [modalMonitoringInfoBiddingOpened, setModalMonitoringInfoBiddingOpened] =
    useState<boolean>(false);
  const [modalNote, setModalNote] = useState<boolean>(false);
  const multi = asksCompany(trading?.monitored_by_companies);
  const [companyAction, setCompanyAction] = useState<CompanyAction | null>(null);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const portals = MonitoringPortals(profile.beta_tester);

  const dispatch = useDispatch();

  const isCurrentUserMonitoring = trading?.monitored_by?.some((m) => m.id === profile.id);

  const currentUserMonitor: MonitoredByTypes = {
    id: profile.id,
    nome: profile.name,
    acronym_name:
      profile.name
        ?.split(' ')
        .map((n: string) => n[0])
        .join('')
        .slice(0, 2) || '',
  };

  const tradingId = () => {
    if (trading?.source_id === portals.find((portal) => portal.label === 'Licitações-e')?.value)
      return <TradingId description="Nº Licitação" tradingId={trading?.trading_id} />;

    return null;
  };

  const copyToClipboard = () => {
    const element = document.querySelector('.uasg');

    if (!element) return;

    if (Clipboard.copyElement(element)) setBalloonText('Número copiado com sucesso.');
  };

  if (!trading) return <div />;

  return (
    <div className="monitoring-header p-3 border-bottom text-white">
      <div className="row">
        <div className="col-md-10 pr-0">
          <div className="mb-0 d-flex align-items-center">
            <strong className="h6 mb-0">{trading?.bidding?.edital || null}</strong>
            {tradingId()}
          </div>
          <div className="monitoring-header-orgao mr-4">
            <strong className="mr-1">Órgão:</strong>
            <span
              className="uasg badge badge-secondary mx-1 databalloon"
              onClick={() => copyToClipboard()}
              onMouseOut={() => setBalloonText('Clique para copiar o número.')}
              aria-label={balloonText}
              data-balloon-pos="up"
              data-balloon-blunt
            >
              {trading?.bidding?.public_body?.uasg || null}
            </span>
            <span className=" mr-3">{`- ${trading.bidding?.public_body?.nome || null}`}</span>
          </div>

          <div className="monitoring-header-data d-flex align-items-center">
            <strong className="mr-1">Datas: </strong>
            <div className="d-flex flex-wrap">
              {!trading?.bidding?.datahora_abertura &&
                !trading?.bidding?.datahora_prazo &&
                !trading?.bidding?.datahora_documento &&
                !trading?.bidding?.datahora_retirada &&
                !trading?.bidding?.datahora_visita &&
                'Não Informadas'}

              {trading?.bidding?.datahora_abertura && (
                <BiddingDate date={trading?.bidding?.datahora_abertura} dateType="Abertura" />
              )}
              {trading?.bidding?.datahora_prazo && (
                <BiddingDate date={trading?.bidding?.datahora_prazo} dateType="Prazo" />
              )}
              {trading?.bidding?.datahora_documento && (
                <BiddingDate date={trading?.bidding?.datahora_documento} dateType="Documento" />
              )}
              {trading?.bidding?.datahora_retirada && (
                <BiddingDate date={trading?.bidding?.datahora_retirada} dateType="Retirada" />
              )}
              {trading?.bidding?.datahora_visita && (
                <BiddingDate date={trading?.bidding?.datahora_visita} dateType="Visita" />
              )}
            </div>
          </div>
        </div>
        <div className="col-md-2 d-flex justify-content-md-end justify-content-center mt-md-0 mt-2 align-items-center">
          {trading?.have_messages && trading?.bidding && (
            <button
              type="button"
              className="btn btn-light btn-sm  btn-ia d-flex align-items-center btn-sm mr-1"
              onClick={() => {
                createTrack(`Monitoramento Chat - Clicou resumo IA`);
                setOverviewOpen((prev) => !prev);
              }}
              style={{
                gap: 8,
                background: 'linear-gradient(135deg, #007bff, #00c6a7)',
                border: 'none',
                borderRadius: 3,
              }}
            >
              <img alt="Ícone IA" src={iconIA} height="26" />
            </button>
          )}
          {trading?.lots?.length >= 1 && (
            <IconActionButton
              icon="done_all"
              ariaLabel="Marcar todas as notificações como lidas"
              disabled={trading?.lots?.length < 1}
              onClick={() => {
                const targets = multi
                  ? ownCompanies(trading?.monitored_by_companies).map((company) => company.id)
                  : [companyId(profile)];
                targets.forEach((target) => dispatch(markAsRead(trading?.id, null, target)));
                createTrack('Monitorar Chat - Marcar todas as notificações como lidas');
              }}
            />
          )}
          <IconActionButton
            icon="refresh"
            ariaLabel="Buscar atualizações"
            onClick={() => {
              dispatch(getTradingMessages(selectedTradingId));
              createTrack('Monitorar Chat - Buscar atualizações');
            }}
          />
          <IconActionButton
            icon="search"
            ariaLabel="Pesquisar mensagens"
            onClick={() => {
              setShowSearchMessage(true);
              createTrack('Monitorar Chat - Pesquisar mensagens');
            }}
          />
          <div className="dropdown mx-1">
            <button
              className="btn btn-light btn-sm d-flex justify-content-center align-items-center dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="material-icons p-0 m-0">more_vert</i>
            </button>
            <div
              className="dropdown-menu p-0 dropdown-menu-right"
              aria-labelledby="dropdownMenuButton"
            >
              {multi && (
                <DropdownActionItem
                  className="rounded-top"
                  onClick={() => setCompanyAction('important')}
                >
                  Importante
                </DropdownActionItem>
              )}
              {multi && (
                <DropdownActionItem onClick={() => setCompanyAction('archive')}>
                  Arquivar ou desarquivar
                </DropdownActionItem>
              )}
              {!multi && !trading?.archived && isCurrentUserMonitoring && (
                <DropdownActionItem
                  className="rounded-top"
                  onClick={() => {
                    dispatch(toggleImportant(trading?.bidding?.id, companyId(profile)));

                    trading?.important
                      ? createTrack('Monitorar Chat - Removeu dos Importantes', {
                          bidding: trading.bidding?.id,
                        })
                      : createTrack('Monitorar Chat - Marcou como importante', {
                          bidding: trading.bidding?.id,
                        });
                  }}
                >
                  {trading?.important ? 'Remover dos Importantes' : 'Marcar como importante'}
                </DropdownActionItem>
              )}
              {!multi && isCurrentUserMonitoring && (
                <DropdownActionItem
                  onClick={() => {
                    dispatch(archive(trading?.bidding?.id, companyId(profile), profile?.id));

                    trading?.archived
                      ? createTrack('Monitorar Chat - Desarquivou a licitação', {
                          bidding: trading.bidding?.id,
                        })
                      : createTrack('Monitorar Chat - Arquivou a licitação', {
                          bidding: trading.bidding?.id,
                        });
                  }}
                >
                  {trading?.archived ? 'Desarquivar' : 'Arquivar licitação'}
                </DropdownActionItem>
              )}
              <DropdownActionItem
                onClick={() => {
                  setModalMonitoringInfoBiddingOpened(true);
                  createTrack('Monitorar Chat - Informações da Licitação');
                }}
              >
                Informações da Licitação
              </DropdownActionItem>
              <button
                type="button"
                className="dropdown-item p-3 rounded-top"
                data-toggle="modal"
                data-target="#monitoring-modal"
                onClick={() => {
                  setModalNote(true);
                  dispatch(getComments(String(trading?.bidding?.id)));
                  createTrack('Monitorar Chat - abriu as anotações');
                  track('monitorar_chat.consultou');
                }}
              >
                Anotações
              </button>
              <a
                className="dropdown-item p-3"
                href={
                  trading.bidding_url ||
                  portals.find((portal) => portal.value === trading.source_id)?.sourceUrl
                }
                target="_blank"
                rel="noreferrer"
              >
                Acessar local da disputa
              </a>
              {multi && (
                <button
                  type="button"
                  className="dropdown-item border-top p-3 rounded-bottom"
                  onClick={() => setCompanyAction('unmonitor')}
                >
                  Desativar monitoramento
                </button>
              )}
              {!multi && isCurrentUserMonitoring && (
                <button
                  className="dropdown-item border-top p-3 rounded-bottom"
                  onClick={() => {
                    dispatch(destroyElectronicsTradings(trading.bidding_id, companyId(profile)));
                    dispatch({
                      type: MonitoringRequestTypes.REMOVE_MONITORED_BY,
                      biddingId: trading.bidding_id,
                      monitor: currentUserMonitor,
                    });
                  }}
                >
                  Desativar monitoramento
                </button>
              )}
              {!multi && !isCurrentUserMonitoring && (
                <button
                  className="dropdown-item border-top p-3 rounded-bottom"
                  onClick={async () => {
                    await createMonitoreBidding({
                      biddingId: trading.bidding_id,
                      setIsLoading: () => {},
                      setMonitored: () => {},
                      companyId: companyId(profile),
                    });
                    dispatch({
                      type: MonitoringRequestTypes.ADD_MONITORED_BY,
                      biddingId: trading.bidding_id,
                      monitor: currentUserMonitor,
                    });
                  }}
                >
                  Ativar monitoramento de chat
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <MonitoringInfoBiddingModal
        modalMonitoringInfoBiddingOpened={modalMonitoringInfoBiddingOpened}
        setModalMonitoringInfoBiddingOpened={setModalMonitoringInfoBiddingOpened}
        bidding={trading.bidding}
      />
      <ModalNotes
        modalNote={modalNote}
        setModalNote={setModalNote}
        bidding_id={trading.bidding?.id}
      />
      <MonitoringCompanyActionModal
        action={companyAction}
        biddingId={trading.bidding_id}
        edital={trading.bidding?.edital}
        companies={trading.monitored_by_companies}
        onClose={() => setCompanyAction(null)}
        onDone={onCompaniesChanged}
      />
    </div>
  );
};

export default TradingContentItem;
